const getPrivacyPolicyLink = (locale, navigateToFeedbackSection) => {
  let privacyLink = "";
  switch (locale) {
    case "en-ca":
      privacyLink = "https://www.vistaprint.ca/vista-privacy-and-cookie-notice";
      break;
    case "en-au":
      privacyLink = "https://www.vistaprint.com.au/vista-privacy-and-cookie-notice";
      break;
    default:
      privacyLink = "https://www.vistaprint.com/vista-privacy-and-cookie-notice";
  }
  if (navigateToFeedbackSection) {
    privacyLink = `${privacyLink}#what-personal-information`;
  }
  return privacyLink;
};

export { getPrivacyPolicyLink };
//# sourceMappingURL=src-config-privacy-link.js.map
